import { generatePath, Link } from 'react-router-dom'

import * as Routes from '@piv/portal/app/routes'

interface Props {
  id: string
  name: string
}

export function PackageLink({ id, name }: Readonly<Props>) {
  return (
    <Link
      to={{
        pathname: generatePath(Routes.Explore.Detail, { id }),
        search: '?view-all=1',
      }}
    >
      {name}
    </Link>
  )
}
